var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Input from './Input';
import Tooltip from './Tooltip';

/**
 * Acceptable patterns for minute/hour input
 *
 *  1h
 *  1m
 *  1h1m
 *  1h 1m
 *  1 h 1 m
 */
var durationRe = /^((\d*)\s*(h?))?\s*((\d*)\s?(m?))?\s*$/i;

var DurationInput = function (_Component) {
  _inherits(DurationInput, _Component);

  function DurationInput(props) {
    _classCallCheck(this, DurationInput);

    var _this = _possibleConstructorReturn(this, (DurationInput.__proto__ || Object.getPrototypeOf(DurationInput)).call(this, props));

    _this.getFormattedValue = function (value) {
      var hours = Math.floor(value / 60);
      var minutes = value % 60;

      return hours + ' h ' + minutes + ' m';
    };

    _this.handleChange = function (value, event) {
      var state = {
        value: value
      };

      if (_this.props.onChange) {
        var match = value.match(durationRe);
        if (match) {
          state.validationError = false;

          // Assume both hours and minutes
          var hours = parseInt(match[2] || 0, 10);
          var minutes = parseInt(match[5] || 0, 10);
          if (match[6] && !match[3]) {
            // Only minutes were specified
            minutes = hours;
            hours = 0;
          }
          _this.props.onChange(hours * 60 + minutes, event);
        }
      }

      _this.setState(state);
    };

    _this.handleBlur = function (value, event) {
      var match = value.match(durationRe);
      if (match) {
        _this.setState({ value: _this.getFormattedValue(_this.props.value), validationError: false });
      } else {
        _this.setState({ value: value, validationError: true });
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(value, event);
      }
    };

    _this.state = {
      value: _this.getFormattedValue(props.value)
    };
    return _this;
  }

  _createClass(DurationInput, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        Input,
        Object.assign({}, this.props, {
          validationError: this.props.validationError || this.state.validationError,
          value: this.state.value,
          onChange: this.handleChange,
          onBlur: this.handleBlur
        }),
        this.state.validationError ? React.createElement(
          Tooltip,
          { left: true, 'static': true },
          React.createElement(FormattedMessage, { id: 'module.common.hours.minutes.format.warning' })
        ) : null
      );
    }
  }]);

  return DurationInput;
}(Component);

DurationInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validationError: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};
DurationInput.defaultProps = {
  value: 0,
  validationError: false,
  onChange: null,
  onBlur: null
};


export default DurationInput;